document.addEventListener('DOMContentLoaded', function () {
  var bar = document.getElementById('sticky-cart');
  if (!bar) return;
  var submitWrap = bar.querySelector('.sticky-submit-wrap');

  function startStickyLoading() {
    if (!submitWrap) return;

    clearTimeout(bar._stickyLoadingFallback);
    submitWrap.classList.add('is-loading');
    bar._stickyLoadingFallback = setTimeout(function () {
      submitWrap.classList.remove('is-loading');
    }, 1200);
  }

  bar.addEventListener('click', function (e) {
    var btn = e.target.closest('.sticky-qty-btn');
    if (!btn) return;
    var input = bar.querySelector('.sticky-qty-input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    if (btn.classList.contains('sticky-qty-plus')) {
      input.value = val + 1;
    } else if (btn.classList.contains('sticky-qty-minus')) {
      if (val > 1) input.value = val - 1;
    }
  });

  document.addEventListener('click', function (e) {
    var stickySubmit = e.target.closest('#sticky-cart .js-ajax-submit');
    if (!stickySubmit) return;
    if (stickySubmit.disabled || stickySubmit.classList.contains('disabled')) return;
    startStickyLoading();
  }, true);
});
